export default __webpack_public_path__ + "assets/images/69b432c69f93365cf196a109ccdbceda.jpg";